// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2l8sH","info":"UpdateTermsInfo_info__1eI3A"};